import o from"./_root.js";import e from"./stubFalse.js";var t="object"==typeof exports&&exports&&!exports.nodeType&&exports,r=t&&"object"==typeof module&&module&&!module.nodeType&&module,p=r&&r.exports===t?o.Buffer:void 0,s=(p?p.isBuffer:void 0)||e;export{s as default};
//# sourceMappingURL=isBuffer.js.map
